import React from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'

import { RichLinks, RichContent } from '../../utils/html'

import { Container, Label, Heading } from './section-header.styles'


const SectionHeader = ({label,heading}) => {
	return (
		<Container>
			{label && <Label>{label}</Label>}
			<Heading><RichContent render={heading} /></Heading>
		</Container>
	)
}

export default SectionHeader;